import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { FullScreenImagePreviewTrigger } from '../FullScreenImagePreview';
import { LazyImage } from '../LazyImage';
import { pagePreviewSrc } from '../../lib/pagePreviewSrc';

export function DocumentPagePdfColumn({
  pageId,
  pageNumberLabel,
  pageIds,
}: {
  pageId: string;
  pageNumberLabel: string;
  // Ordered ids of all the document's pages, so the full-screen preview can flip
  // prev/next (+ arrow keys) across the document.
  pageIds?: string[];
}) {
  return (
    <div
      className={twMerge(
        clsx('bg-gray-50 dark:bg-zinc-800 aspect-3/4 shadow-[0_0_10px_rgba(0,0,0,0.1)] relative group'),
      )}
    >
      <LazyImage src={pagePreviewSrc(pageId, { resize: 'x800' })} className="w-full h-full" />
      <div className="absolute bottom-2 inset-x-0 text-center text-xs text-gray-500 pointer-events-none">
        Page {pageNumberLabel}
      </div>

      <FullScreenImagePreviewTrigger pageId={pageId} pageIds={pageIds} />
    </div>
  );
}
